/*
 * ColorSelect Messages
 *
 * This contains all the text for the ColorSelect component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.ColorSelect.header',
    defaultMessage: 'Select a Color',
  },
  darkBlue: {
    id: 'app.components.ColorSelect.darkBlue',
    defaultMessage: 'Dark Blue',
  },
  lightBlue: {
    id: 'app.components.ColorSelect.lightBlue',
    defaultMessage: 'Light Blue',
  },
  seagreen: {
    id: 'app.components.ColorSelect.seagreen',
    defaultMessage: 'Seagreen',
  },
  darkGreen: {
    id: 'app.components.ColorSelect.darkGreen',
    defaultMessage: 'Dark Green',
  },
  lightGreen: {
    id: 'app.components.ColorSelect.lightGreen',
    defaultMessage: 'Light Green',
  },
  yellow: {
    id: 'app.components.ColorSelect.yellow',
    defaultMessage: 'Yellow',
  },
  orange: {
    id: 'app.components.ColorSelect.orange',
    defaultMessage: 'Orange',
  },
  pink: {
    id: 'app.components.ColorSelect.pink',
    defaultMessage: 'Pink',
  },
  red: {
    id: 'app.components.ColorSelect.red',
    defaultMessage: 'Red',
  },
  purple: {
    id: 'app.components.ColorSelect.purple',
    defaultMessage: 'Purple',
  },
  gray: {
    id: 'app.components.ColorSelect.gray',
    defaultMessage: 'Gray',
  },
  lightBrown: {
    id: 'app.components.ColorSelect.lightBrown',
    defaultMessage: 'Light Brown',
  },
  darkBrown: {
    id: 'app.components.ColorSelect.darkBrown',
    defaultMessage: 'Dark Brown',
  },
  anthracite: {
    id: 'app.components.ColorSelect.anthracite',
    defaultMessage: 'Anthracite',
  },
});
